<template>
    <div>
      <div v-for="(_, index) in skeletonCount" :key="index" class="skeleton-loader">
        <!-- Skeleton loader filter options -->
        <div class="filter-options">
          <!-- Filter by Job Type -->
          <div class="filter-type">
            <h3 class="filter-title skeleton"></h3>
            <div class="filter-item">
              <div class="filter-select">
                <label class="skeleton"></label>
              </div>
              <div class="filter-select">
                <label class="skeleton"></label>
              </div>
            </div>
          </div>
          <!-- Filter by Job Location -->
          <div class="filter-type">
            <h3 class="filter-title skeleton"></h3>
            <div class="filter-item">
              <div class="filter-select">
                <label class="skeleton"></label>
              </div>
              <div class="filter-select">
                <label class="skeleton"></label>
              </div>
              <div class="filter-select">
                <label class="skeleton"></label>
              </div>
              <!-- Add more filter-select skeleton items as needed -->
            </div>
          </div>
          <!-- Filter by -->
          <div class="el-radio-group" role="radiogroup">
            <h3 class="filter-title skeleton"></h3>
            <label class="skeleton">
            </label>
            <label class="skeleton">
            </label>
          </div>
          <!-- Custom Slider -->
          <div class="custom-slider-skeleton">
              <div class="filter-title skeleton">
              </div>

              <div class="slider-skeleton skeleton">
                </div>
              
              <div class="min-max-skeleton-wrapper">
                    <span class="skeleton min-value"></span>
                    <span class="skeleton max-value"></span>
                </div>
          </div>

          <!-- Tagged Skills -->
          <div class="filter-type">
            <h3 class="filter-title skeleton"></h3>
            <div class="filter-item">
              <div class="filter-select">
                <label class="skeleton"></label>
              </div>
              <div class="filter-select">
                <label class="skeleton"></label>
              </div>
              <div class="filter-select">
                <label class="skeleton"></label>
              </div>
              <div class="filter-select">
                <label class="skeleton"></label>
              </div>
              <!-- Add more filter-select skeleton items as needed -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      skeletonCount: Number // Define the prop to receive the count of skeleton items
    }
  };
  </script>
  
  <style scoped>
  /* Skeleton loader styles */
  .skeleton {
    background: linear-gradient(90deg, rgba(240,240,240,1) 25%, rgba(225,225,225,1) 50%, rgba(240,240,240,1) 75%);
    background-size: 400% 100%;
    animation: shimmer 1.5s infinite linear;
  }
  
  @keyframes shimmer {
    0% {
      background-position: 100% 0;
    }
    100% {
      background-position: -100% 0;
    }
  }
  
  /* Your component-specific skeleton loader styles */
  .filter-options {
    /* Add your styles */
  }
  
  .filter-type {
    /* Add your styles */
  }
  
  .filter-title {
    /* Add your styles */
  }
  
  .filter-item {
    /* Add your styles */
  }
  
  .filter-select {
    /* Add your styles */
  }
  
  .el-radio-group {
    /* Add your styles */
  }
  
  .custom-slider {
    /* Add your styles */
  }
  
  .min-value,
  .max-value {
    /* Add your styles */
  }
  
  .range-input,
  .range-path,
  .range-fill,
  .slider-marker {
    /* Add your styles */
  }
  
  /* Add more specific styles as needed */

  .skeleton-loader {
    .filter-title.skeleton {
        height: 19px;
        max-width: 40%;
        border-radius: 6px;
    }
    
    .filter-select {
        width: 12%;
        
        label.skeleton {
            border: 0;
            width: 100%;
            height: 24px;
        }
    
        &:nth-child(2n + 1) {
            width: 15%
        }
    }

    .custom-slider-skeleton {

        .min-max-skeleton-wrapper {
            display: flex;
            justify-content: space-between;
            margin-top: 8px;
        }
        
        .skeleton {
            width: 100%;
            height: 19px;

            &.min-value,
            &.max-value {
                display: inline-flex;
                height: 19px;
                width: 40px;
                border-radius: 6px;
                margin-bottom: 1rem;
            }
        }
    }
}
  </style>
  